import type { BaseUserRepository } from "../../_Bases/BaseUserRepository";
import type { LocalDatabaseUser } from "../../_Bases/BaseUserRepository";
import type { InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBUserRepository extends BaseIndexedDBRepository<
    LocalDatabaseUser
> implements BaseUserRepository {
    public readonly source: InternalIndexedDBDatabase["users"];
    protected readonly dataTypeName = "User";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.users;
    }

    public get(uuid: string): Promise<LocalDatabaseUser> {
        // Return the shopfront user
        if(uuid === "11e6d61b3dec425286c45cf9dd713698") {
            /* eslint-disable @typescript-eslint/naming-convention */
            return Promise.resolve({
                dashboard         : "[]",
                email             : "",
                image             : "",
                is_api_user       : false,
                last_login_at     : null,
                name              : "Shopfront",
                permissions       : null,
                phone             : "",
                quick_menu        : [],
                role_id           : "",
                sale_keys         : "",
                sale_keys_position: "default",
                username          : "shopfront",
                uuid              : "11e6d61b3dec425286c45cf9dd713698",
                dark_mode         : "default",
                favourite_fields  : {
                    product: [],
                },
            });
            /* eslint-enable @typescript-eslint/naming-convention */
        }

        return super.get(uuid);
    }

    public getUserByUsername(username: string): Promise<LocalDatabaseUser> {
        return this.source
            .where("username")
            .equalsIgnoreCase(username)
            .first();
    }

    public search(value: string): Promise<Array<LocalDatabaseUser>> {
        const needle = value.trim().toLowerCase();

        if(!needle) {
            return this.all();
        }

        return this.source
            .filter(user => {
                return user.name.toLowerCase().includes(needle);
            })
            .toArray();
    }
}
